import React from "react";
import styles from "../assets/luxuryHouseSitting.module.css";

const LuxuryHouseSitting = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>Luxury House Sitting Solutions</h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we understand the importance of peace of mind
              when it comes to leaving your luxury property unattended. Our
              high-end house sitting service offers bespoke solutions for
              discerning homeowners seeking reliable and discreet property
              management.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Exclusivity</h4>
                <p className={styles.featureDescription}>
                  Our high-end house sitting service is tailored for luxury
                  properties, providing exclusive care and attention to your
                  property.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Professionalism</h4>
                <p className={styles.featureDescription}>
                  Our team of experienced house sitters are trained
                  professionals who prioritize the security and maintenance of
                  your property.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Discretion</h4>
                <p className={styles.featureDescription}>
                  We understand the need for privacy and discretion in the
                  luxury market, and we ensure utmost confidentiality in all our
                  engagements.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Customization</h4>
                <p className={styles.featureDescription}>
                  Every house sitting arrangement is customized to meet your
                  specific requirements and preferences.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Services</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Property Oversight</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>24/7 Monitoring</h4>
                  <p className={styles.serviceDescription}>
                    Our house sitters provide round-the-clock monitoring of your
                    property, ensuring its security and integrity at all times.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Interior Care</h4>
                  <p className={styles.serviceDescription}>
                    From basic maintenance tasks to overseeing specialized
                    services such as cleaning and repairs, we ensure your
                    interior space is impeccably maintained.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Exterior Maintenance</h4>
                  <p className={styles.serviceDescription}>
                    We also take care of the exterior of your property,
                    including landscaping, pool maintenance, and any other
                    outdoor amenities.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Concierge Services</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Personalized Assistance
                  </h4>
                  <p className={styles.serviceDescription}>
                    Our concierge services extend beyond property management to
                    cater to your lifestyle needs, including grocery shopping,
                    event planning, and more.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Guest Hosting</h4>
                  <p className={styles.serviceDescription}>
                    Hosting guests? Let us take care of the arrangements, from
                    preparing the guest rooms to ensuring their comfort during
                    their stay.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Get in Touch</h4>
            <p className={styles.contactDescription}>
              Experience the ultimate peace of mind with our high-end house
              sitting service. Contact us today to discuss your luxury property
              management needs and discover how Global Guardians can elevate
              your homeownership experience.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LuxuryHouseSitting;
